/* eslint-disable react/prop-types */
import React from 'react';

var defaultRenderButton = function defaultRenderButton(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      label = _ref.label;
  return React.createElement("button", {
    type: "button",
    className: className,
    onClick: onClick
  }, label);
};

export default defaultRenderButton;